var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPureColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 567.18 144.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5f8dda;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.54,61.54h18.31c14.92,0,24.91-8.08,24.91-21.29s-9.57-21.5-21.5-21.5h-21.72V61.54ZM21.54,27.25c0-5.31-3-8.5-8.31-8.5H0V0H89.22c34.92,0,55.59,10.87,55.59,40s-20.67,40.29-59.81,40.29h-23.46v33.64c0,5.32,3,8.52,8.31,8.52h14.26v18.74H.22v-18.74H13.22c5.32,0,8.31-3.2,8.31-8.52V27.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.62,141.19v-16.4h-.43c-9.37,13.63-19.38,19.59-36.63,19.59-24.28,0-32.38-10.43-32.38-33.43v-43.23c0-6-1.47-9.15-7.65-9.15h-7v-17h50v62.82c0,15.12,0,20.88,16.4,20.88,9.79,0,16-9.17,16-18.11v-39.44c0-6-1.49-9.15-7.66-9.15h-9.38v-17h52.4V115c0,6,1.48,9.15,7.65,9.15h7.67v17l-48.99,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.51,41.53h50.24v17h.43c4.26-10.23,12.36-20.23,24.93-20.23,13.25-.15,24.12,10.47,24.27,23.73,0,.18,0,.37,0,.55,0,9.16-7,18.94-17,18.94-8.94,0-17-4.26-17-14.06,0-7.23,4.05-11.71,11.07-13-2.13-2.14-4-2.35-6.81-2.35-11.08,0-18.31,14.26-18.31,24.69v38.2c0,6,1.49,9.17,7.66,9.17h8.72v17h-68.2v-17h8.73c6.18,0,7.66-3.2,7.66-9.17v-47.28c0-6-1.48-9.15-7.66-9.15h-8.73v-17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M473.93,79.22v-5.53c0-10.86-5.75-18.32-16-18.32s-16.19,7.46-16.19,18.32v5.53h32.19Zm-32.58,17c0,14.9,3.41,29.81,21.29,29.81,7.45,0,19.6-5.76,21.51-18.32h24.71c-3.41,25.55-28.32,36.64-51.33,36.64-36.4,0-53.87-20.24-53.87-53s23.43-53,53.87-53c34.72,0,54.1,24.69,54.1,57.92l-70.28-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.18,126.49c-.17,9.77-8.12,17.62-17.89,17.68-9.74-.05-17.62-7.94-17.67-17.68,.06-9.77,7.9-17.71,17.67-17.89,9.82,.13,17.76,8.07,17.89,17.89"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPureColored);
export default __webpack_public_path__ + "static/media/pure-colored.bbfcd693625174d789cc32b5f6005c37.svg";
export { ForwardRef as ReactComponent };